import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AgendaGradeLinha } from '../../../../interfaces/agenda';
import { AgendaModaisService } from '../../../../services/agenda/agenda-modais.service';
import { AgendaService, mensagemErroAgenda } from '../../../../services/agenda/agenda.service';
import { corpoDesvincular, motivoAcaoLinha } from '../agenda-acoes';

/** Limpa o NR_ATENDIMENTO do agendamento; o atendimento e a conta continuam existindo. */
@Component({
  selector: 'app-agenda-desvincular',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './agenda-desvincular.component.html',
  styleUrl: './agenda-desvincular.component.scss',
})
export class AgendaDesvincularComponent implements OnInit, OnDestroy {
  @Input({ required: true }) linha!: AgendaGradeLinha;

  @Output() fechar = new EventEmitter<void>();
  @Output() salvo = new EventEmitter<string>();

  salvando = false;
  erro = '';

  private fecharRegistro: (() => void) | null = null;

  constructor(private api: AgendaService, private modais: AgendaModaisService) {}

  ngOnInit() {
    this.fecharRegistro = this.modais.abrir();
  }

  ngOnDestroy() {
    this.fecharRegistro?.();
    this.fecharRegistro = null;
  }

  @HostListener('document:keydown.escape')
  aoEsc() {
    if (!this.modais.coberto()) this.cancelar();
  }

  cancelar() {
    if (!this.salvando) this.fechar.emit();
  }

  get impedimento(): string | null { return motivoAcaoLinha('desvincular', this.linha); }

  async confirmar() {
    if (this.salvando || this.impedimento) return;
    this.salvando = true;
    this.erro = '';
    const nr = this.linha.paciente.nrAtendimento;
    try {
      await this.api.desvincularConta(this.linha.nrSequencia, corpoDesvincular(this.linha));
      this.salvo.emit(`Atendimento ${nr} desvinculado do horário ${this.linha.hrInicio}.`);
    } catch (e) {
      this.erro = mensagemErroAgenda(e, 'Erro ao desvincular a conta.');
    } finally {
      this.salvando = false;
    }
  }
}
